export const environment = {
    production: false,
    caseDetailsByIDInfoAPIUrl: 'https://dev-integrations.evhc.net/api/v1/caretool/caseinfo/',
    caseDetailsByIDAPIUrl: 'https://dev-integrations.evhc.net/api/v1/caretool/cases/',
    saveCaseDetailsAPIUrl: 'https://dev-integrations.evhc.net/api/v1/caretool/cases/',
    providerInfoAPIUrl: 'https://dev-integrations.evhc.net/api/v1/caretool/providers',
    formValuesAPIUrl:'https://dev-integrations.evhc.net/api/v1/caretool/cases/formvalues',
    casehistoryAPIUrl: 'https://dev-integrations.evhc.net/api/v1/caretool/casehistory',
    clientIDValue:'',
    clientSecretValue:'',
    caserecPatientDemographicAPIUrl:'https://dev-integrations.evhc.net/api/v1/caretool/caserec/cases/',
    fileuploadUrl: 'https://dev-integrations.evhc.net/api/v1/caretool/cases/',
    //logServiceUrl: 'https://dev-integrations.evhc.net/api/v1/caretool/log?logType=Logstash',
    logServiceUrl: 'https://p49qo5vem4.execute-api.us-east-1.amazonaws.com/dev/weblog',
    envName : "dev",
    informationLogging: true,
    logIndexName: "quality-cqf-logs-dev",
    cutoffdate: "05/01/2024",
    cutoffdatePQRAnes4: "01/01/2025"
};